import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { Empty } from "antd";
import { useAtomValue } from "jotai";
import { ProfileCards } from "../style";
import CustomfieldDisplay from "@portal/BaseComponents/Activites/RaiseADispute/CustomfieldDisplay";

const t = {
  AdditionalInformation: "Additional Information",
};

export interface AdditionalInfoCustomFieldProps {}

function AdditionalInformation(props: AdditionalInfoCustomFieldProps) {
  const config = useAtomValue(userConfigAtom);
  return (
    <ProfileCards title={t.AdditionalInformation}>
      {config.user_details?.customer.custom_fields?.length ? (
        <CustomfieldDisplay
          type={'CUSTOMER'}
          customFieldData={config.user_details?.customer.custom_fields}
        />
      ) : (
        <Empty
          description="No additional info available"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </ProfileCards>
  );
}
export { AdditionalInformation };
